/**
 * Route logic.
 * Here's where the route configurations get retrieved and processed into react
 * components.
 */

/**
 * Dependencies
 */
import React from 'react';
import { Route, Switch } from 'react-router';
import universal from '@nerdwallet/nw-app-module/universal';
import { preloadIdentity } from '@nerdwallet/js-auth-tools/actions';

/**
 * Local Dependencies
 */
import Container from './container';
import ConfigPage from '../containers/config-page/config-page';
import { loadConfigRoute } from '../lib/route-utils';

// JSX Routes
const BuilderContainer = universal(import('../containers/builder/container'));

// JSX routes
export const BUILDER_SLUG = 'builder';

const dataDependencies = [
  {
    path: '/',
    loadData: async (opts, callback) => {
      const { store, req, res } = opts;
      store.dispatch(preloadIdentity(res.locals.data, req, res));

      await loadConfigRoute(opts);

      callback();
    },
  },
];

const appFrom = (Component) => () => (
  <Container>
    <Component />
  </Container>
);

export default (
  <Switch dataDependencies={dataDependencies}>
    <Route path={`/l/${BUILDER_SLUG}`} component={appFrom(BuilderContainer)} />
    <Route path="/" component={appFrom(ConfigPage)} />
  </Switch>
);
